import { loadable } from '@change-corgi/core-react/loadable';

import type { AppRoute } from '#src/shared/routes';

import { Loading } from '#src/app/shared/routes';

export const ROUTES: readonly AppRoute[] = [
	{
		id: 'impact',
		path: '/impact',
		component: loadable(async () => import(/* webpackChunkName: "pages/impact" */ './index'), {
			exportName: 'Impact',
			fallback: Loading,
		}),
		frame: true,
		ssr: {
			// switch this to true to enable SSR
			enabled: true,
			seo: true,
		},
	},
];
